import { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';


export default async function clientTokenVerificationUtils() {

    const queryClient = useQueryClient();
    const clientUser = useSelector((state) => state.main.client);
    const [isTokenValid, setIsTokenValid] = useState(true);
    const {
        data: reqData,
        isFetching,
    } = useQuery(
        ['client_token', clientUser?.data?.id],
        () => {
            console.log('Calling verifyClientAuthTokenSession', clientUser?.data?.id);
            return api.verifyClientAuthTokenSession(clientUser?.data?.id);
        },
        {
            enabled: !!clientUser?.data?.id,
            // refetchInterval: 60000, // Refetch every 1 minute
            // refetchIntervalInBackground: true,
            onError: (error) => {
                console.error('API error:', error);
            }
        }
    );

    console.log(reqData?.data?.data?.valid_token);
    useEffect(() => {
        setIsTokenValid(reqData?.data?.data?.valid_token);
        console.log('validToken', reqData?.data?.data?.valid_token);
    }, [reqData])

    return isTokenValid;
}
